//  Name: container-main
import '@/components/title-bar'

export default {
  props: [],
  mounted () {
    document.body.style.backgroundColor = "#d9eef7"
  },
  beforeDestroy () {
    document.body.style.backgroundColor = "#FFF"
  }
}



// WEBPACK FOOTER //
// ./src/components/container-main/script.js